import { InverseHeader } from '@jouzen/ecom-components';

import LandingPageAccuracy from '@/app/components/LandingPage/LandingPageAccuracy';

import accuracyCards from './data/accuracyCards';

const WhyOuraAccuracy = (): JSX.Element => {
  return (
    <section className="relative py-16 md:py-0" data-cy="why-oura-accuracy">
      <InverseHeader enter>
        <LandingPageAccuracy
          accuracyCards={accuracyCards}
          backgroundImage={{
            className: 'object-cover',
            fill: true,
            localizedAlt: 'accuracy_image_alt',
            srcSet: [
              {
                src: 'blue-sky/why-oura/accuracy',
              },
            ],
          }}
          description="accuracy_description"
          descriptionShadowColor="#000000"
          title="accuracy_title"
        />
      </InverseHeader>
    </section>
  );
};

export default WhyOuraAccuracy;
